module.exports = __webpack_public_path__ + "img/campus_Image_b.ae61b501.png";